import * as requests_authentication from './apis/auth'
import * as requests_personel from './apis/personel'
import * as request_cardtable from './apis/cardtable'
import * as request_legalRequestFiles from './apis/legalRequestFiles'
import * as request_user from './apis/user'
import * as request_dashboard from './apis/dashboard'
import * as request_setting from './apis/setting'
import * as request_tickets from './apis/tickets'
import * as request_plans from './apis/plans'
import * as letter_plans from './apis/letter'
import * as wrote_plans from './apis/wrote'
import * as request_requestZamen from './apis/requestZamen'
import * as faq_services from './apis/faq'
import * as surveyCategory_services from './apis/surveyCategory'
import * as survey_services from './apis/survey'
import * as supportVideo_services from './apis/supportVideo'
import * as request_services from './apis/request'
import * as backCheques_services from './apis/backcheques'
import * as facilityinquiry_services from './apis/facilityinquiry'
import * as requestZamenCheques_services from './apis/requestZamenCheques'
import * as surveyAnswer_services from './apis/surveyAnswer'
import * as archivedDocument_services from './apis/archivedDocument'
import * as notifications_services from './apis/notifications'
import * as contract_services from './apis/contract'

export const ServiceAgent = {
  auth: requests_authentication,
  personel: requests_personel,
  cardtable: request_cardtable,
  legalRequestFiles: request_legalRequestFiles,
  user: request_user,
  dashboard: request_dashboard,
  setting: request_setting,
  tickets: request_tickets,
  plans: request_plans,
  letter: letter_plans,
  wrote: wrote_plans,
  requestZamen: request_requestZamen,
  faq: faq_services,
  surveyCategory: surveyCategory_services,
  survey: survey_services,
  supportVideo: supportVideo_services,
  request: request_services,
  backCheques: backCheques_services,
  facilityinquiry: facilityinquiry_services,
  requestZamenCheques: requestZamenCheques_services,
  surveyAnswer: surveyAnswer_services,
  archivedDocument: archivedDocument_services,
  notifications: notifications_services,
  contract: contract_services,
}
